const global = window;

inputs.alias.time = 'date';
inputs.alias.datetime = 'date';

// inputs.typesDelay.date = 1

inputs.fn.date = {
    configureDateMinMax(config, input, date, prop, inputWindow) {
        const momentDate = moment(date, 'YYYY-MM-DD', true);
        if (momentDate.isValid()) {
            config[`${prop}Date`] = momentDate.format('Y-m-d');
            data[prop] = null;
        } else {
            const inputTarget = inputWindow.find(`[data-name="${date}"]`);
            config[`${prop}Date`] = $(inputTarget).val() || false;
            inputTarget.change(function () {
                input.data('xdsoft_datetimepicker').setOptions({
                    [`${prop}Date`]: $(this).val() || false,
                });
            });
        }
    },
}

inputs.types.date = function (data, name, niceName, type, input, parent, inputWindow) {
    $.datetimepicker.setLocale('fr');

    const isDatetime = data.type === 'datetime';
    const darkTheme = (input.closest('.block--dark').length || window.darkTheme);

    const config = {
        lang: 'fr',
        format: `Y-m-d${isDatetime ? ' H:i' : ''}`,
        allowBlank: true,
        timepicker: isDatetime,
        inline: data.inline,
        theme: darkTheme ? 'dark' : 'default',
        nullButton: !data.mandatory,
        trigger: data.trigger
    };

    if (data.min) {
        inputs.fn.date.configureDateMinMax(config, input, data.min, 'min', inputWindow);
    }

    if (data.max) {
        inputs.fn.date.configureDateMinMax(config, input, data.max, 'max', inputWindow);
    }

    input.datetimepicker(config);

    // Gestion du Copier / Couper / Coller
    input.on('keydown', function (e) {
        if (e.ctrlKey || e.metaKey) {
            const key = e.key.toLowerCase();
            if (key === 'c' || key === 'x') {
                const val = input.val();
                let toCopy = val;

                if (val) {
                    const m = moment(val, [
                        'YYYY-MM-DD HH:mm',
                        'YYYY-MM-DD',
                        'DD/MM/YYYY HH:mm',
                        'DD/MM/YYYY',
                        'YYYY/MM/DD HH:mm',
                        'YYYY/MM/DD'
                    ], false); // On utilise false pour être plus souple sur les formats d'entrée lors de la copie

                    if (m.isValid()) {
                        toCopy = m.format('YYYY-MM-DD HH:mm');
                    }
                }

                clipboardCopy(toCopy, true);
                if (key === 'x') {
                    input.val('');
                    input.trigger('change');
                }
                e.preventDefault();
            }
        }
    });

    input.on('paste', function (e) {
        const clipboardData = (e.originalEvent || e).clipboardData || window.clipboardData;
        const pastedData = clipboardData.getData('text');

        if (pastedData) {
            const isDatetime = (data.type === 'datetime');
            const m = moment(pastedData, [
                moment.ISO_8601,
                'YYYY-MM-DD HH:mm',
                'YYYY-MM-DD',
                'DD/MM/YYYY HH:mm',
                'DD/MM/YYYY',
                'YYYY/MM/DD HH:mm',
                'YYYY/MM/DD'
            ], true);

            if (m.isValid()) {
                const format = isDatetime ? 'YYYY-MM-DD HH:mm' : 'YYYY-MM-DD';
                const formatted = m.format(format);
                input.val(formatted);
                input.datetimepicker('setOptions', {value: formatted});
                input.trigger('change');
                input.datetimepicker('hide');
            }
        }
        e.preventDefault();
    });

    return data;
};
